import { render } from "./IdDemo.vue?vue&type=template&id=5dfe05a7&scoped=true"
import script from "./IdDemo.vue?vue&type=script&lang=js"
export * from "./IdDemo.vue?vue&type=script&lang=js"

import "./IdDemo.vue?vue&type=style&index=0&id=5dfe05a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfe05a7"]])

export default __exports__